import { render } from "./BaseConvertor.vue?vue&type=template&id=4e4b41a2&scoped=true"
import script from "./BaseConvertor.vue?vue&type=script&lang=js"
export * from "./BaseConvertor.vue?vue&type=script&lang=js"

import "./BaseConvertor.vue?vue&type=style&index=0&id=4e4b41a2&scoped=true&lang=css"

import exportComponent from "/Users/sunnyng/Dev/bc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e4b41a2"]])

export default __exports__